module.exports = __webpack_public_path__ + "static/media/otpconfig.1f63bea4.svg";